import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
// import useCartStore from '../DataRepo/CartStore';
import TeleConsultationStore from "../DataRepository/TeleConsultationStore";
import star from "../Assets/images/Orange Outline star.png";
import sethos from "../Assets/images/sethos icon.png";
// import next from "../public/icons/next.png";

import heart from "../Assets/images/orange heart icon.png";
import { getDynamicLogo } from '../getDynamicLogo';
import phoneiconimg from '../Assets/images/mobile.png'
import emailiconimg from '../Assets/images/G-mail.png'
import cautionimg from "../Assets/images/Caution icon 1.png";
import { CircularProgress } from "@mui/material";
import { toast, Zoom } from "react-toastify";
import { teleConsultationModel } from "../Axios/AxiosConfig";
import LoadingComponent from "../loading"


function Profile() {
  const {
    getDoctorDetails,
    DoctorDetails,
    getDoctorSlots,
    Slots,
    slotErrResponse,
    isDoctorsLoading,
  } = TeleConsultationStore();

  const navigate = useNavigate();
  const location = useLocation();
  const [selectedDay, setSelectedDay] = useState(dayjs());
  const [selectedSlots, setSelectedSlots] = useState(Slots);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const datesContainerRef = useRef(null);

  const scrollDays = (offset) => {
    if (datesContainerRef.current) {
      datesContainerRef.current.scrollBy({ left: offset, behavior: "smooth" });
    }
  };

  const doctorDetailsCookie = Cookies.get("Doctor_details");
  let Doctor_details = {};
  if (doctorDetailsCookie) {
    try {
      Doctor_details = JSON.parse(doctorDetailsCookie);
    } catch (error) {
      console.log("Error parsing Doctor_details cookie:", error);
    }
  }

  const [selectedTime, setSelectedTime] = useState("");

  const queryParams = new URLSearchParams(location.search);

  const id = Doctor_details.PID;

  useEffect(() => {
    getDoctorDetails(Doctor_details.PID);
    getDoctorSlots(Doctor_details.PID, selectedDay.format("YYYY-MM-DD"));
  }, [location]);

  useEffect(() => {
    getDoctorDetails(Doctor_details.PID);
    getDoctorSlots(Doctor_details.PID, selectedDay.format("YYYY-MM-DD"));
  }, [location]);

  const handleSelectDay = (date) => {
    if (!date) return;
    setSelectedDay(date);
    getDoctorSlots(Doctor_details.PID, date.format("YYYY-MM-DD"));
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const today = new Date();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedDate, setSelectedDate] = useState(currentDate);

  const formatMonth = (monthIndex) => {
    const year = today.getFullYear();
    const monthFormatted = (monthIndex + 1).toString().padStart(2, "0");
    return `${year}-${monthFormatted}`;
  };

  const formatDate = (monthIndex, day) => {
    const year = today.getFullYear();
    const monthFormatted = (monthIndex + 1).toString().padStart(2, "0");
    const dayFormatted = day.toString().padStart(2, "0");
    return `${year}-${monthFormatted}-${dayFormatted}`;
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const dateFormatted = formatDate(selectedMonth, date);
    console.log(`Date selected: ${dateFormatted}`);
  };

  const renderDays = () => {
    const today = new Date();
    const todayDate = today.getDate();
    const selectedMonth = today.getMonth();
    const selectedYear = today.getFullYear();

    const days = [];

    for (let i = 0; i < 14; i++) {
      const nextDay = new Date(today);
      nextDay.setDate(todayDate + i);
      // if (nextDay.getMonth() !== selectedMonth) break;
      days.push(nextDay);
    }

    return days.map((day) => (
      <div
        key={day.toString()}
        onClick={() => {
          handleSelectDay(dayjs(day));
          handleDateClick(day.getDate());
          setSelectedTime("");
        }}
        style={{
          cursor: "pointer",
          borderRadius: "4px",
          textAlign: "center",
          backgroundColor: "#FAF6EC",
          border: selectedDate === day.getDate() ? "1px solid #d9730d" : "none",
        }}
      >
        <div
          style={{
            padding: "5px 10px",
            fontWeight: 400,
            fontSize: "10px",
            borderRadius: "4px",
            backgroundColor: "var(--themeSecondaryColor, #f4ecd6)",
          }}
        >
          {months[selectedMonth].toUpperCase()}
        </div>

        <div
          style={{
            padding: "5px 10px",
            fontWeight: 400,
            fontSize: "14px",
          }}
        >
          {daysOfWeek[day.getDay()]}
        </div>

        <div>{day.getDate().toString().padStart(2, "0")}</div>
      </div>
    ));
  };
  const [isActive, setIsActive] = useState(false);
  const [updatedSlots, setUpdatedSlots] = useState([]); // Store updated slots

  const toggleSwitch = () => {
    setIsActive(!isActive);
  };
  const toggleSelectAll = () => {
    setIsSelectAll((prevIsSelectAll) => {
      // Toggle ON: Select all "Free" slots and mark them as blocked
      if (!prevIsSelectAll) {
        const freeSlots = Slots.filter((slot) => slot.Status === "Free").map(
          (slot) => slot.slot
        );
        setSelectedSlots(freeSlots);

        setUpdatedSlots(
          Slots.map((slot) =>
            freeSlots.includes(slot.slot) ? { ...slot, blocked: true } : slot
          )
        );
      }
      // Toggle OFF: Reset all slots to unblocked
      else {
        setSelectedSlots([]);
        setUpdatedSlots(Slots.map((slot) => ({ ...slot, blocked: false })));
      }

      return !prevIsSelectAll; // Toggle the state
    });
  };

  // Handle individual slot selection
  const toggleSlotSelection = (slotTime) => {
    setSelectedSlots((prevSelected) => {
      const newSelectedSlots = prevSelected.includes(slotTime)
        ? prevSelected.filter((time) => time !== slotTime)
        : [...prevSelected, slotTime];

      // Update `updatedSlots` based on the new selectedSlots
      const newUpdatedSlots = Slots.map((slot) =>
        newSelectedSlots.includes(slot.slot)
          ? { ...slot, blocked: !slot.blocked }
          : { ...slot }
      );

      setUpdatedSlots(newUpdatedSlots);
      return newSelectedSlots;
    });
  };


  const handleSaveSlots = async () => {
    if (!selectedSlots.length) {
      toast.warn("Please select at least one slot before saving.", {
        position: "top-center",
        limit: 1,
        autoClose: 2000,
        theme: "dark",
      });
      return;
    }

    // Toggle the blocked status for each selected slot

    if (updatedSlots.length === 0) {
      toast.info("No changes detected.", {
        position: "top-center",
        limit: 1,
        autoClose: 2000,
        theme: "dark",
      });
      return;
    }

    const payload = {
      UID: Doctor_details.PID,
      date: selectedDay.format("YYYY-MM-DD"),
      timings: updatedSlots, // Send only modified slots
    };

    try {
      let res = await teleConsultationModel.put("/updateAvailability", payload);
      if (res?.status === 200) {
        toast.success("Slots saved successfully!", {
          position: "top-center",
          limit: 1,
          autoClose: 2000,
          theme: "dark",
        });
      }
      window.location.reload();
    } catch (error) {
      console.error("Error saving slots:", error);
      toast.error("Error saving slots. Please try again.", {
        position: "top-center",
        limit: 1,
        autoClose: 2000,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    // Clear selected slots whenever selectedDay changes
    setSelectedSlots([]);
    setIsSelectAll(false);
  }, [selectedDay]);

  useEffect(() => {
    // If needed, call a function to re-fetch your slots data:
    // fetchSlots();
    // For now, this effect simply runs on refresh change.
  }, [refresh]);

  return (
    <div className="flex flex-col md:flex-row h-screen poppins-font">
      {isDoctorsLoading ? (
        <LoadingComponent loading={teleConsultationModel} />
      ) : (
        <>
          <div>

            <div className="All-products-section-main">
             
              <div className="Tele-consultation-book-main-container">

                <div className="Tele-consultation-doctor-details">
                  <div>
                    <img
                      src={DoctorDetails?.img || "placeholder-image-url"}
                      alt={DoctorDetails?.name || "Doctor Image"}
                    />
                    <div className="doc-info-card">
                      <div className="icon-text">
                        <img src={star} alt="Star" />
                        <p>{DoctorDetails?.rating}</p>
                      </div>
                      <div className="icon-text">
                        <img src={sethos} alt="Experience" />
                        <p>{DoctorDetails?.experience}+ years</p>
                      </div>
                      <div className="icon-text">
                        <img src={heart} alt="Treated Patients" />
                        <p>{DoctorDetails?.treated}+ treated patients</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start justify-between mb-[20px]">
                    {/* Left Side: Doctor Details */}
                    <div className="flex flex-col items-start gap-5 pt-[5px] pb-[5px]">
                      
                      <div className="flex items-center gap-5 mb-[12px]">
                        <p className="text-[var(--themePrimaryColor, #3B362A)] text-2xl font-bold">
                          {DoctorDetails?.name}
                        </p>
                        <p className="text-[var(--themePrimaryColor, #3B362A)] text-lg ">
                          {DoctorDetails?.course_details}
                        </p>
                      </div>

                      <p className="text-[color:var(--themePrimaryColor,#312110)] text-xl">
                        Ayurveda Physician
                      </p>
                    </div>
                    <button
                      style={{
                        textTransform: "none",
                        backgroundcolor: "var(--themePrimaryColor, #312110)",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "5px 10px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      onClick={() => navigate("/edit-profile")}
                    >
                      <img
                        src="/icons/edit_icon_white.png"
                        alt="Edit"
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                      Edit Profile
                    </button>
                  </div>

                  <p className="text-[#625E55] text-sm  mb-[20px] ">
                    {DoctorDetails?.about}
                  </p>
                  <div className="flex flex-col bg-[#E7E7DB99] pt-[10px] pb-[10px] pl-[19px]  mb-[10px] rounded-[8px]">
                    <div className="flex flex-col items-start pt-[1px] pb-[1px]">
                      <p className="text-[var(--themePrimaryColor, #3B362A)] text-lg font-bold mb-[10px]">
                        Languages Known
                      </p>
                      <div className="flex items-start space-x-4">
                        {DoctorDetails?.language_known
                          ?.split(", ")
                          .map((lang, index, arr) => (
                            <div key={index} className="flex items-center">
                              <p className="text-[#625E55] text-sm">{lang}</p>

                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-start py-[5px]">
                    <p className="text-[var(--themePrimaryColor, #3B362A)] text-lg font-bold mb-[13px]">
                      Contact Information
                    </p>
                    <div className="flex items-center gap-[20px] ml-[8px] mb-[11px]">
                      <img
                        src={phoneiconimg}
                        className="w-[26px] h-[24px] object-fill"
                        alt="Phone Icon"
                      />
                      <p className="text-[#625E55] text-sm">
                        {DoctorDetails?.phone || "Not Available"}
                      </p>
                    </div>
                    <div className="flex items-center gap-[20px] ml-[8px]">
                      <img
                        src={emailiconimg}
                        className="w-[26px] h-[24px] object-fill"
                        alt="Email Icon"
                      />
                      <p className="text-[#625E55] text-sm">
                        {DoctorDetails?.email || "Not Available"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="Tele-consultation-doctor-slots">
                  <div>
                    <p className="choosetimingslottitle mb-2  align-center">
                      Select Date
                    </p>
                    <div className="date-navigation-container mb-10 align-center">
                      <button
                        className="nav-button left"
                        onClick={() => scrollDays(-200)}
                      >
                        <ChevronLeft />
                      </button>

                      <div className="dates-wrapper" ref={datesContainerRef}>
                        <div className="dates-list">{renderDays()}</div>
                      </div>

                      <button
                        className="nav-button right"
                        onClick={() => scrollDays(200)}
                      >
                        <ChevronRight />
                      </button>
                    </div>
                  </div>
                  <div>

                    <div className="select-all-container mt-1">
                      <p className="choosetimingslottitle">Select Unavailable Slots</p>
                      <div className="indicatorList">
                        <div className="indicatorProfile">
                          <div className="boxProfile bookedProfile"></div>
                          <p>Booked</p>
                        </div>
                        <div className="indicatorProfile">
                          <div className="boxProfile blockedProfile"></div>
                          <p>Blocked</p>
                        </div>
                        <div className="indicatorProfile">
                          <div className="boxProfile freeProfile"></div>
                          <p>Selected</p>
                        </div>
                      </div>
                    </div>
                    {Slots?.length > 0 && (
                      <div className="toggle-wrapper mt-5">
                        <p className="select-all">Select all</p>
                        <div
                          className={`toggle-container ${isSelectAll ? "active" : ""}`}
                          onClick={toggleSelectAll}
                        >
                          <div className="toggle-background"></div>
                          <div className="toggle-knob"></div>
                        </div>
                      </div>
                    )}
                    <div>
                      <div className="Slot-container mt-7">
                        {Slots.map((slot, index) => {
                          let slotStyle = {};
                          let onClickHandler = () => toggleSlotSelection(slot.slot);

                          // Condition 1: Booked Slot
                          if (slot.Status === "Booked") {
                            slotStyle = {
                              backgroundColor: "#8CEB8C",
                              color: "black",
                              cursor: "not-allowed",
                            };
                            onClickHandler = null;
                          }
                          // Condition 2: Blocked Slot
                          else if (slot.blocked) {
                            slotStyle = {
                              backgroundColor: "#D6D6D6",
                              color: "#A5A39D",
                              cursor: "pointer",
                            };
                          }
                          // Condition 3: Selected Slot
                          else if (selectedSlots.includes(slot.slot)) {
                            slotStyle = {
                              backgroundColor: "var(--themePrimaryColor, #DA6E0B)",
                              color: "white",
                              border: "1px solid var(--themePrimaryColor, #DA6E0B)",
                              cursor: "pointer",
                            };
                          }
                          // Condition 4: Available
                          else {
                            slotStyle = {
                              backgroundColor: "white",
                              color: "var(--themePrimaryColor, #DA6E0B)",
                              border: "1px solid var(--themePrimaryColor, #DA6E0B)",
                              cursor: "pointer",
                            };
                          }

                          return (
                            <div
                              key={index}
                              className={`slot-item ${selectedSlots.includes(slot.slot) ? "selected" : ""
                                }`}
                              onClick={onClickHandler}
                              style={slotStyle}
                            >
                              <p>{slot.slot}</p>
                            </div>
                          );
                        })}
                      </div>
                      <div>
                        {slotErrResponse && (
                          <div className="slot-error-container">
                            <div className="slot-error-content">
                              <img
                                src={cautionimg}
                                alt="Warning Icon"
                                className="slot-error-icon"
                              />
                              <p className="slot-error-message">
                                {slotErrResponse.message}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      position: "fixed",
                      bottom: "20px",
                      right: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      onClick={handleSaveSlots}
                      style={{
                        textTransform: "none",
                        backgroundColor: "var(--themePrimaryColor, #DA6E0B)",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "10px 20px",
                        cursor: "pointer",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      Save Slots
                    </button>
                  </div>
                </div>

              </div>



            </div>

          </div>
        </>
      )}
    </div>


  );
}

export default Profile;
